<template>
  <div class="chemical-industry">
    <s-r-m-header ref="header" activeVal='chemicalIndustry' />
    <carousel-container ref="carouselContainer" :carouselInfo="carouselInfo" dark />
    <PointOfPain 
      ref="characteristic" 
      :listData="listData" 
      title="化工材料行业研发管理中的主要痛点"
      description="技术沉淀与传承、采销产协同、研发效率、数据风险……化工材料行业研发管理面临诸多难题"
    />
    <PlatformOverview></PlatformOverview>
    <product-features
      title="化工材料行业PLM的主要功能"
      description="为化工材料等行业客户提供核心技术管理、资源池管理、效率工具、五大基石、数据建模"
      :tabList="tabList"
    ></product-features>
    <p-l-m-a-i-application />
    <success-cases
      ref="successCases"
      title="璞华易研PLM的典型案例"
      description="多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率"
      :caseList="caseList"
    />
    <KeyAdvantages :banner-height="bannerHeight2"></KeyAdvantages>
    <!-- <Scheme :schemeList="schemeList"></Scheme>  -->
    <ChooseUs :nameVals="['ChemicalIndustry', 'Food', 'Pharmaceutical', 'WearMakeup']" :scrollNum="3"></ChooseUs>
    <custom-form ref="customForm" />
    <footer-box />
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import PointOfPain from "@/components/PointOfPain/index"
import PlatformOverview from "@/components/PlatformOverview"
import ProductFeatures from "@/components/ProductFeatures"
import PLMAIApplication from "@/components/PLMAIApplication"
import SuccessCases from "@/components/SuccessCases"
import KeyAdvantages from "@/components/KeyAdvantages"
import Scheme from "@/components/Scheme"
import ChooseUs from "@/components/ChooseUs"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import { baiduConsult } from "./common.js";

import hgs1 from '@/assets/images/zym-hg.png'
import gn1 from '@/assets/images/gn1-1.png'
import gn2 from '@/assets/images/gn1-2.png'
import gn3 from '@/assets/images/gn1-3.png'
import gn4 from '@/assets/images/gn1-4.png'
import gn5 from '@/assets/images/gn1-5.png'

import al1 from '@/assets/images/al1-1.png'
import al2 from '@/assets/images/al1-2.png'
import al3 from '@/assets/images/al1-3.png'

import al4 from '@/assets/images/al1-4.jpg'
import al5 from '@/assets/images/al1-5.jpg'
import al6 from '@/assets/images/al1-6.jpg'
import al7 from '@/assets/images/al1-7.jpg'


import hg1 from '@/assets/images/hg1.png'
import hg2 from '@/assets/images/hg2.png'
import hg3 from '@/assets/images/hg3.png'
import hg4 from '@/assets/images/hg4.png'
import hg5 from '@/assets/images/hg5.png'

import dz1 from '@/assets/images/dz1.png'
import dz2 from '@/assets/images/dz2.png'
import dz3 from '@/assets/images/dz3.png'
import dz4 from '@/assets/images/dz4.png'
import dz5 from '@/assets/images/dz5.png'
import dz6 from '@/assets/images/dz6.png'

export default {
  components: {
    SRMHeader,
    CarouselContainer,
    PointOfPain,
    CustomForm,
    FooterBox,
    ProductFeatures,
    PLMAIApplication,
    Scheme,
    PlatformOverview,
    ChooseUs,
    SuccessCases,
    KeyAdvantages
  },
  metaInfo() {
    return {
      title: '化工PLM软件_材料PLM系统_化工材料行业PLM解决方案_国产PLM供应商_PLM厂家_PLM产品_PLM排名',
      meta: [
        {
          name: 'keywords',
          content: '化工材料PLM,化工PLM,新材料研发管理,材料PLM,高分子材料PLM,香精香料PLM,涂料PLM,电子烟油PLM,石化PLM,轮胎PLM'
        },
        {
          name: 'description',
          content: '璞华易研化工材料PLM系统，聚焦化工行业研发难题，提供化工PLM,材料PLM,涂料PLM,胶粘剂PLM,染料PLM,电子烟油PLM,化工配方管理系统,化工研发管理系统,lims实验管理，工艺管理，合规管理，研发全流程协同的一整套产品全生命周期管理系统，加速化工材料研发进程，提升生产效率，助力化工企业抢占市场高地。'
        }
      ]
    }
  },
  data() {
    return {
      ratio: null,
      bannerHeight2: null,
      carouselInfo: {
        title: '化工材料行业PLM',
        description: '高分子、改性材料、胶黏剂、涂料油漆、化工试剂、半导体材料、新能源材料…… <br/> 贯穿新材料需求、设计、实验、中试、小批量、放量、优化、运营等全生命周期',
        bg: hgs1
      },
      tabList: [
        {
          name: 'first',
          label: '技术核心管理',
          title: '1. 技术核心管理',
          description: '围绕需求与实验，精细化管理资源池，实现高效的后勤保障、资源调度与资源复用',
          effectDrawing: gn1,
          contentList: [
            {
              title1: '配方管理',
              content1: 'BOM结构化、正反结构查询、替代料管理、自动计算、研发/生产多场景视图、版本比较'
            },
            {
              title1: '工艺管理',
              content1: '文件模板化、参数指标结构化、图文表并茂式呈现、单/多工序场景差异化维护、装备设备管理'
            },
            {
              
              title1: '实验过程管理',
              content1: '配方工艺多途径维护、样品物性数据可视化对比、自动出具实验与检验报告、权限多维度细分'
            },
            {
              title1: '材料成本分析',
              content1: '配方材料成本自动计算、物料价格走势图表化比对'
            },
            {
              title1: '配方成本预测',
              content1: '物料价格影响利润预测、配方成本虚拟运算、浮动情况可视化比较'
            }
          ]
        },
        {
          name: 'second',
          label: '资源池管理',
          title: '2. 资源池管理',
          description: '以配方、工艺、成本为核心，整合产品全生命周期数据，涓汇、沉淀经验库',
          effectDrawing: gn2,
          contentList: [
            {
              title1: '配方高级检索',
              content1: 'B支持以物性要求、原料占比等多条件维度检索产品配方资源池，获取适配的历史经验参考'
            },
            {
              title1: '实验设备看板',
              content1: '支持设备资产管理，动态维护实验设备状态，预约协调档期，利用率、故障率可视化统计'
            },
            {
              title1: '实验人员看板',
              content1: '支持看板动态维护实验人员状态，预约、协调其档期，支持工时统计、比较'
            },
            {
              title1: '实验物料库存',
              content1: '支持实验物料出入库管理，自动扣减实验打样所耗物料，提供呆滞料数量、价值可视化统计'
            },
            {
              title1: '模具耗材管理',
              content1: '提供实验模具、耗材等出入库管理台账，自动分配编号批号，助力资源库存预警，及时补货备货'
            }
          ]
        },
        {
          name: 'third',
          label: '效率工具',
          title: '3. 效率工具',
          description: '基于提质增效目标，配套灵活的个性化效率工具，助力研发活动响应效率',
          effectDrawing: gn3,
          contentList: [
            {
              title1: '系统模板',
              content1: '内置多套材料化工行业文件模板方案，支持用户个性化自定义、扩展'
            },
            {
              title1: '代办授权',
              content1: '支持业务流程临时委托代办授权，支持各对象读写用临时授权，配套快速审核等在线监督机制'
            },
            {
              title1: '流程效率分析',
              content1: '提供业务流程效率分析，支持以流程类型、流转节点、操作者等多维度分析业务流转效率'
            },
            {
              title1: '在线可视化',
              content1: '采用最新的BS架构，支持40多种主流的文件格式在线预览，所见即所得；配套多场景自动图表'
            },
            {
              title1: '第三方集成',
              content1: '自带主流的集成接口，轻松实现与ERP、MES、办公软件等的集成协同，支持数据导出'
            }
          ]
        },
        {
          name: 'four',
          label: '五大基石',
          title: '4. 五大基石',
          description: '内置材料化工通用的业务对象管理，为产品履历、数据分析、知识传承奠定坚实的基础',
          effectDrawing: gn4,
          contentList: [
            {
              title1: '物料',
              content1: '编码规则自定义、型号/牌号关联、属性配置、生命周期管理、版本管理、分类分组定义、自动转码等'
            },
            {
              title1: '文档',
              content1: '内置行业常用文档模型（如标准法规、检验规范、检测项目等），支持自定义扩展、分类分组管理等'
            },
            {
              title1: '流程',
              content1: '内置行业常用ECR-ECO变更方案，提供行业领先的用户可编程引擎，支持拖曳式自定义配置'
            },
            {
              title1: '报表',
              content1: '预置多场景自动图表（如对比图、统计图、走势图等）与分析表单，支持导出与打印'
            },
            {
              title1: '项目',
              content1: '项目计划+项目进度+项目交付+项目报表，帮助企业实现项目集管理，规范项目数据，缩短研发周期'
            }
          ]
        },
        {
          name: 'five',
          label: '数据建模',
          title: '5. 数据建模',
          description: '通过数据建模，支持客户个性化需求的高效灵活扩展，适应企业业务的发展衍变',
          effectDrawing: gn5,
          contentList: [
            {
              title1: '模型管理',
              content1: '支持数据、流程、字段级别的数据建模和精细化的权限控制'
            },
            {
              title1: '配置扩展',
              content1: '支持根据客户的个性化需求配置基础设置、对象分类、对象属性、工作流程、权限等'
            },
            {
              title1: '编码版本',
              content1: '支持适配企业体系化管理的各种编码、版本规则定义，支持内部文件与外来文件的差异化管理'
            },
            {
              title1: '用户管理',
              content1: '组织架构管理、用户信息管理、隶属关系管理、状态管理、行为日志、角色关联列表'
            },
            {
              title1: '角色权限',
              content1: '角色配置、用户关联、字段级数据权限、菜单权限、页签权限、按钮权限、读写权限'
            }
          ]
        }
      ],
      caseList: [
        {
          label: '科顺防水科技PLM系统实施',
          link: 'https://www.plmcenter.cn/cases/case-keshun/',
          describe: '缺乏统一的项目管理平台，研发资料管理混乱，产品数据共享困难，上下游协同效率低，配方数据安全管理存在风险。',
          advantage: ['数据管理完整性与一致性显著提升', '物料管理实现唯一数据源'],
          img: al4
        },
        {
          label: '道尔顿电子材料PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-dalton/',
          describe: '技术文档存储不规范、版本不一致，业务流程不规范、流程与数据脱离，产品数据与实验数据分层管理困难，研发项目进度监控难把控。',
          advantage: ['提升数据标准化及溯源和流程规范（50%）', '提升开发和协同效率（30%）'],
          img: al5
        },
        {
          label: '化讯半导体材料PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-huaxun/',
          describe: '作为专注于高端半导体材料研发的企业，化讯半导体在集成电路先进封装、功率器件、新型显示等领域面临数据管理不规范、研发协同效率低、产品开发周期长等挑战。',
          advantage: ['整合数据夯实数字平台基础（提升数据标准化 50%）', '落地协同研发平台，提升产品研发效率（提升研发效率 30%）'],
          img: al6
        },
        {
          label: '汉旸科技光刻胶材料PLM数字化转型',
          link: 'https://www.plmcenter.cn/cases/case-hanyang/',
          describe: '面对复杂市场与技术挑战，汉旸科技传统研发模式难以适应发展，高效利用研发数据、提升配方效率、实现跨部门协同成关键。研发项目管理面临项目监管效能低、计划管理粗放、经费管控薄弱、跨部门协作低效、系统整合受阻、缺失数据决策支撑等六大挑战。',
          advantage: ['研发规范性与周期优化', '产能与订单承接能力提升'],
          img: al7
        },
        {
          label: '通讯材料行业',
          link: 'https://www.purvar.com/case/c-plm-cailiao-tongxin.html',
          describe: '数据离散存储 Excel、共享不安全、复用与追溯困难；研发资源冲突频发、实验易延期；技术文件不规范、交付物缺失；产品履历不完整、重复开发浪费严重。',
          advantage: ['实现实验 / 配方 / 工艺 / 成本数据一体化，研发效率显著提升', '研发资源透明化管理，避免档期冲突与实验延期'],
          img: al1
        },
        // {
        //   label: '电子材料行业',
        //   link: 'https://www.purvar.com/case/c-plm-cailiao-dianzi.html',
        //   img: al2
        // },
        {
          label: '石油白油行业',
          link: 'https://www.purvar.com/case/c-plm-cailiao-shiyou.html',
          describe: '料物性批次波动大，配方需人工适配计算耗时长；质检数据存于Excel，共享滞后、查阅与复用困难；配方重量转体积人工核算，效率低且易出错。',
          advantage: ['实现配方智能推荐，缩短订单交付周期（40%）', '提升质检数据复用与查阅效率（50%）'],
          img: al3
        }
      ],
      schemeList: [
        {
          val: '01',
          label: '化工材料行业',
          title: '应用场景',
          descriptions: [
            '目前，世界范围内化工产业发展迅速，新产品不断推出。同时，市场竞争加剧，产品同质化倾向比较明显，对数字化转型的要求也越来越高。需要覆盖产品全生命周期的闭环研发体系、跨部门跨地域的协同研发体系、基于数据收集和分析的数据建模数据管理体系、以及与第三方系统进行高效对接的系统集成机制。', 
            '璞华易研PLM基于10多年的PLM咨询实施经验，因应化工行业的发展需求，为化工行业提供最佳实践。',
            '我们在化工行业拥有丰富的咨询和实施经验，为客户在激烈的市场竞争中提升产品竞争力。'
          ],
          mainDesc: '化工材料行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '02',
          label: '电子高科技',
          title: '应用场景',
          descriptions: [
            '最近几年，电子高科技行业呈现出激烈的竞争局面，产品上市速度快，具有创新性的产品也不断推出。要在电子产品领域赢得竞争，必须面向消费者、关注设计、富有创新、快速推向市场，产品的全生命周期管理显得越来越重要。',
            '为了因应这一时代潮流，璞华易研PLM关注数据建模和数据管理，通过项目管理和变更管理，推动部门之间、地域之间进行无缝协作，强化与第三方系统的对接，让产品生命周期管理变得快捷、高效。'
          ],
          mainDesc: '电子高科技行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '03',
          label: '芯片半导体',
          title: '应用场景',
          descriptions: [
            '设计成本上涨、产品日益复杂、创新步伐加快，这些均给半导体企业造成很大的压力。该行业研发设计挑战艰巨、生命周期日益缩短。璞华易研PLM，帮助芯片半导体客户极大的改善了新产品开发和生命周期的流程管理。'
          ],
          mainDesc: '芯片半导体行业的PLM应用主要包括以下主要内容',
          mianFeatures: [
            { icon: dz1, label: '数据管理' },
            { icon: dz2, label: '数据建模' },
            { icon: dz3, label: '变更管理' },
            { icon: dz4, label: '项目管理' },
            { icon: dz5, label: '在线可视化' },
            { icon: dz6, label: '第三方接入' }
          ]
        },
        {
          val: '04',
          label: '医疗器械',
          title: '应用场景',
          descriptions: [
            '医疗器械行业对产品安全性和有效性要求特别高，因此对产品的设计、生产过程要求尤其严格。',
            '医疗器械制造商的竞争也日趋激烈，使得企业在产品管理方面迫切需要通过一种更为系统化、更为全面、更高效的产品生命周期管理方法以及对应的管理平台来迎接这些新挑战。',
          ],
          mainDesc: '医疗器械行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        },
        {
          val: '05',
          label: '工业制造',
          title: '应用场景',
          descriptions: [
            '工业设备等制造业的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研制周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。',
            '企业实施PLM项目管理可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。',
            '璞华易研PLM能帮助企业在管理和工作效率方面得到极大提升，实现上游技术部门和下游生产制造部门之间信息及时传递和共享。'
          ],
          mainDesc: '工业制造行业的PLM应用主要包括以下主要内容。',
          mianFeatures: [
            { icon: hg1, label: '实验室管理' },
            { icon: hg2, label: '配方管理' },
            { icon: hg3, label: '工艺管理' },
            { icon: hg4, label: '物料管理' },
            { icon: hg5, label: '第三方工具集成' }
          ]
        }
      ],
      listData: [
        {
          num: '01',
          title: '技术沉淀与传承缺有力抓手',
          contentList: [
            {
              content: '产品配方、工艺数据履历不完整'
            },
            {
              content: '打样、测评数据离散，追溯、复盘不便'
            },
            {
              content: '数据以纸质或Excel存储，编码混乱，复用有效性差'
            },
            {
              content: '技术传递、传承较为主观、随意，缺标准化管理'
            }
          ]
        },
        {
          num: '02',
          title: '采销产响应、协同效率受限',
          contentList: [
            {
              content: '技术文件缺乏机器可读性，难以支撑制造过程监测'
            },
            {
              content: '配方成本计算分析全靠人工，不利于市场快速响应'
            },
            {
              content: '新材料导入缺标准化、规范化的物性测评指引与记录'
            },
            {
              content: '原料市场价格变化对利润的影响缺准时、有效的测算'
            }
          ]
        },
        {
          num: '03',
          title: '研发效率可控性弱',
          contentList: [
            {
              content: '配方设计、数据计算、分析等过度依赖个人的精力'
            },
            {
              content: '缺可快速检索、调用的产品配方库、技术模型库'
            },
            {
              content: '跨组/部门间数据、信息共享准确性、完整性、及时性差'
            },
            {
              content: '实验资源缺透明化的看板，调度耗用过多时间与精力'
            }
          ]
        },
        {
          num: '04',
          title: '数据安全风险大',
          contentList: [
            {
              content: '技术数据若使用即需可见，难以兼顾安全性'
            },
            {
              content: '对技术数据的读写、共享、传承等缺有效监管'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.setSize();
    window.addEventListener("resize", () => {
      this.setSize();
    }, false );

    baiduConsult();
  },
  methods: {
    setSize() {
      this.bannerHeight2 = document.body.clientWidth / (1920 / 450)
      if (document.body.clientWidth < 768) this.bannerHeight2 = 320
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.chemical-industry {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .productfeature .tab-container .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item {
    width: 28rem;
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
